import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDebianDark = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 58,
	height: 59,
	viewBox: "0 0 58 59",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M31.6192 53.2639C24.6866 50.6281 20.5688 47.3931 16.054 40.1737C14.9461 38.1847 12.9089 33.7422 12.9861 27.9521C12.8058 22.1757 15.5677 15.5197 20.7223 11.9677C25.7 8.2188 32.1237 8.16291 35.945 9.64344C39.8868 11.1899 41.4854 13.7662 41.5305 13.6434C41.41 13.6755 43.6422 15.6599 44.6374 19.9796C45.7462 24.1317 44.6201 31.0102 39.2011 33.832C36.7088 35.2438 33.4718 35.4995 30.9335 34.4898C28.3952 33.4078 26.5556 31.0322 25.9393 28.5503C24.6017 23.0708 28.5356 20.0337 30.2712 19.7222C37.3321 17.2339 40.908 28.9113 32.6499 29.9008C36.414 31.2292 40.2943 27.1431 39.5565 22.9883C39.4074 18.8289 34.6429 14.697 29.3878 16.3928C28.0155 16.7932 25.9375 17.811 24.3112 20.1005C22.6433 22.3763 21.8865 25.9429 22.7534 29.4097C23.5987 32.8957 26.169 36.2324 29.7493 37.7285C33.366 39.1385 37.3928 38.7353 40.7182 36.9067C47.8172 33.1953 49.2381 24.1518 47.8276 19.1761C46.5828 13.8285 43.8338 11.3796 43.976 11.342C43.9248 11.4877 41.9474 8.31042 37.0607 6.38189C32.2824 4.5404 24.8288 4.67049 18.8671 9.09099C12.7641 13.2284 9.45519 21.3584 9.69532 27.9109C9.61296 34.565 11.9597 39.6579 13.2401 41.9218C18.4016 50.2406 24.3156 52.8406 31.6183 53.2566",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgDebianDark);
export { ForwardRef as ReactComponent };
